import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import db from '../firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import '../styles.css';

function EditRates() {
  const { country } = useParams();
  
  // 預設值（僅供參考）
  const [airRate, setAirRate] = useState(144);
  // 韓國：各路徑＝台幣／公斤 + 韓幣（國際）／公斤
  const [airTaiwanPerKg, setAirTaiwanPerKg] = useState(144);
  const [airIntlKrwPerKg, setAirIntlKrwPerKg] = useState(0);
  const [transitTaiwanPerKg, setTransitTaiwanPerKg] = useState(125);
  const [transitIntlKrwPerKg, setTransitIntlKrwPerKg] = useState(0);
  const [seaTaiwanPerKg, setSeaTaiwanPerKg] = useState(95);
  const [seaIntlKrwPerKg, setSeaIntlKrwPerKg] = useState(0);
  const [exchangeRate, setExchangeRate] = useState(30);
  const [shippingRate, setShippingRate] = useState(1); // 中國專用
  const [extraPercentage, setExtraPercentage] = useState(0); // 額外%數

  useEffect(() => {
    const fetchRates = async () => {
      const ratesRef = doc(db, 'rates', country);
      const docSnap = await getDoc(ratesRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (country === 'china') {
          setExchangeRate(data.exchangeRate || 30);
          setShippingRate(data.shippingRate || 1);
          setExtraPercentage(data.extraPercentage || 0);
        } else if (country === 'korea') {
          setAirTaiwanPerKg(
            data.airTaiwanPerKg !== undefined && data.airTaiwanPerKg !== null
              ? data.airTaiwanPerKg
              : data.airRate ?? 144
          );
          setAirIntlKrwPerKg(
            data.airIntlKrwPerKg !== undefined && data.airIntlKrwPerKg !== null
              ? data.airIntlKrwPerKg
              : 0
          );
          setTransitTaiwanPerKg(
            data.transitTaiwanPerKg !== undefined && data.transitTaiwanPerKg !== null
              ? data.transitTaiwanPerKg
              : data.transitRate ?? 125
          );
          setTransitIntlKrwPerKg(
            data.transitIntlKrwPerKg !== undefined && data.transitIntlKrwPerKg !== null
              ? data.transitIntlKrwPerKg
              : 0
          );
          setSeaTaiwanPerKg(
            data.seaTaiwanPerKg !== undefined && data.seaTaiwanPerKg !== null
              ? data.seaTaiwanPerKg
              : data.seaRate ?? 95
          );
          setSeaIntlKrwPerKg(
            data.seaIntlKrwPerKg !== undefined && data.seaIntlKrwPerKg !== null
              ? data.seaIntlKrwPerKg
              : 0
          );
          setExchangeRate(data.exchangeRate || 30);
          setExtraPercentage(data.extraPercentage || 0);
        } else if (country === 'japan') {
          setAirRate(data.airRate || 144);
          setExchangeRate(data.exchangeRate || 30);
          setExtraPercentage(data.extraPercentage || 0);
        } else { // 泰國
          setAirRate(data.airRate || 144);
          setExchangeRate(data.exchangeRate || 0.9);
          setExtraPercentage(data.extraPercentage || 0);
        }
      }
    };

    fetchRates();
  }, [country]);

  const handleSave = async () => {
    const ratesRef = doc(db, 'rates', country);
    let ratesData = {};
    if (country === 'china') {
      ratesData = {
        exchangeRate,
        shippingRate,
        extraPercentage,
      };
    } else if (country === 'korea') {
      ratesData = {
        airTaiwanPerKg,
        airIntlKrwPerKg,
        transitTaiwanPerKg,
        transitIntlKrwPerKg,
        seaTaiwanPerKg,
        seaIntlKrwPerKg,
        exchangeRate,
        extraPercentage,
      };
    } else if (country === 'japan') {
      ratesData = {
        airRate,
        exchangeRate,
        extraPercentage,
      };
    } else {
      ratesData = {
        airRate,
        exchangeRate,
        extraPercentage,
      };
    }
    await setDoc(ratesRef, ratesData);
    alert('匯率已保存');
  };

  const pageStyle = {
    minHeight: '100vh',
    background: '#f8f9fa',
    padding: '1rem',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  };

  const cardStyle = {
    background: '#fff',
    borderRadius: '12px',
    padding: '1.5rem',
    marginBottom: '1rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    maxWidth: '480px',
    margin: '0 auto'
  };

  const formGroupStyle = {
    marginBottom: '1.25rem'
  };

  const labelStyle = {
    display: 'block',
    fontSize: '0.9rem',
    fontWeight: '500',
    color: '#666',
    marginBottom: '0.5rem'
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    fontSize: '1rem',
    border: '1px solid #e5e5e5',
    borderRadius: '8px',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s'
  };

  const buttonStyle = {
    background: '#333',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    width: '100%',
    transition: 'all 0.2s',
    marginTop: '1rem'
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1.5rem', color: '#333', textAlign: 'center' }}>編輯匯率</h2>
        {country === 'china' ? (
          <>
            <div style={formGroupStyle}>
              <label style={labelStyle}>匯率 (人民幣轉台幣)</label>
              <input
                type="number"
                value={exchangeRate}
                onChange={(e) => setExchangeRate(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>海快雜貨 運費倍率</label>
              <input
                type="number"
                value={shippingRate}
                onChange={(e) => setShippingRate(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>額外%數 (例如10代表10%)</label>
              <input
                type="number"
                value={extraPercentage}
                onChange={(e) => setExtraPercentage(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
          </>
        ) : country === 'korea' ? (
          <>
            <div style={{ ...formGroupStyle, paddingBottom: '0.5rem', borderBottom: '1px solid #eee' }}>
              <span style={{ ...labelStyle, color: '#333', fontWeight: '600' }}>直飛空運（每公斤）</span>
              <label style={labelStyle}>台灣運費（台幣）</label>
              <input
                type="number"
                value={airTaiwanPerKg}
                onChange={(e) => setAirTaiwanPerKg(Number(e.target.value))}
                style={inputStyle}
              />
              <label style={{ ...labelStyle, marginTop: '0.75rem' }}>國際運費（韓幣）</label>
              <input
                type="number"
                value={airIntlKrwPerKg}
                onChange={(e) => setAirIntlKrwPerKg(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={{ ...formGroupStyle, paddingBottom: '0.5rem', borderBottom: '1px solid #eee' }}>
              <span style={{ ...labelStyle, color: '#333', fontWeight: '600' }}>轉機空運（每公斤）</span>
              <label style={labelStyle}>台灣運費（台幣）</label>
              <input
                type="number"
                value={transitTaiwanPerKg}
                onChange={(e) => setTransitTaiwanPerKg(Number(e.target.value))}
                style={inputStyle}
              />
              <label style={{ ...labelStyle, marginTop: '0.75rem' }}>國際運費（韓幣）</label>
              <input
                type="number"
                value={transitIntlKrwPerKg}
                onChange={(e) => setTransitIntlKrwPerKg(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={{ ...formGroupStyle, paddingBottom: '0.5rem', borderBottom: '1px solid #eee' }}>
              <span style={{ ...labelStyle, color: '#333', fontWeight: '600' }}>海快（每公斤）</span>
              <label style={labelStyle}>台灣運費（台幣）</label>
              <input
                type="number"
                value={seaTaiwanPerKg}
                onChange={(e) => setSeaTaiwanPerKg(Number(e.target.value))}
                style={inputStyle}
              />
              <label style={{ ...labelStyle, marginTop: '0.75rem' }}>國際運費（韓幣）</label>
              <input
                type="number"
                value={seaIntlKrwPerKg}
                onChange={(e) => setSeaIntlKrwPerKg(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>匯率 (韓幣轉台幣)</label>
              <input
                type="number"
                value={exchangeRate}
                onChange={(e) => setExchangeRate(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>額外%數 (例如10代表10%)</label>
              <input
                type="number"
                value={extraPercentage}
                onChange={(e) => setExtraPercentage(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
          </>
        ) : country === 'japan' ? (
          <>
            <div style={formGroupStyle}>
              <label style={labelStyle}>空運公斤</label>
              <input
                type="number"
                value={airRate}
                onChange={(e) => setAirRate(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>匯率 (日幣轉台幣)</label>
              <input
                type="number"
                value={exchangeRate}
                onChange={(e) => setExchangeRate(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>額外%數 (例如10代表10%)</label>
              <input
                type="number"
                value={extraPercentage}
                onChange={(e) => setExtraPercentage(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
          </>
        ) : (
          <>
            <div style={formGroupStyle}>
              <label style={labelStyle}>空運公斤</label>
              <input
                type="number"
                value={airRate}
                onChange={(e) => setAirRate(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>匯率 (泰銖轉台幣)</label>
              <input
                type="number"
                value={exchangeRate}
                onChange={(e) => setExchangeRate(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>額外%數 (例如10代表10%)</label>
              <input
                type="number"
                value={extraPercentage}
                onChange={(e) => setExtraPercentage(Number(e.target.value))}
                style={inputStyle}
              />
            </div>
          </>
        )}
        <button 
          onClick={handleSave}
          style={buttonStyle}
          onMouseOver={(e) => { e.target.style.background = '#555'; }}
          onMouseOut={(e) => { e.target.style.background = '#333'; }}
        >
          保存
        </button>
      </div>
    </div>
  );
}

export default EditRates;

